import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function RequireAuth({
  redirectTo,
  requiredPermission,
  profileGate = false,
  profileRedirectTo = '/compte/profil',
  fallbackTo,
}) {
  const location = useLocation();
  const { user, loading, isAuthenticated, hasPermission } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-primary flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-secondary animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`${redirectTo}?next=${encodeURIComponent(next)}`} replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    const target = fallbackTo || (user?.can_access_backoffice ? '/my/dashboard' : '/compte');
    return <Navigate to={target} replace />;
  }

  if (profileGate && !user?.profile_completed && location.pathname !== profileRedirectTo) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`${profileRedirectTo}?next=${encodeURIComponent(next)}`} replace />;
  }

  return <Outlet />;
}
